module.exports = __webpack_public_path__ + "img/runelist.9b204d82.svg";